import { render } from "./LabelCounts.vue?vue&type=template&id=2ad5d8ba&scoped=true"
import script from "./LabelCounts.vue?vue&type=script&lang=js"
export * from "./LabelCounts.vue?vue&type=script&lang=js"

import "./LabelCounts.vue?vue&type=style&index=0&id=2ad5d8ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad5d8ba"]])

export default __exports__